import React, { useState, useEffect } from 'react';
import { getMarkDown, useDetectMobile } from '../utils';
import TextField from '@mui/material/TextField';
import '../../../stylesheets/triagebot/TextInput.scss';
import { datadogRum } from '@datadog/browser-rum';
import CheckmarkOpenCdo from '../../../assets/checkmark-open-cdo';

const cdoName = process.env.REACT_APP_CDO_NAME;

const TextInputMessage = ({ message, sendMessage, disabled, selfCare911ERSelected, selectedButtonRedirectUrl, closeToast,onSubmit, onFeedbackSubmit }) => {
    const [input, setInput] = useState('');
    const [characterCount, setCharacterCount] = useState(0);
    const MAX_CHAR = 250;
    const isOpenCdo = (cdoName).toLowerCase() === 'open';
 const showDoubleButtons = isOpenCdo && !selfCare911ERSelected;

    const { isMobile } = useDetectMobile();

    sendMessage = (typeof sendMessage === 'function')
        ? sendMessage
        : () => { }

    closeToast = (typeof closeToast === 'function')
        ? closeToast
        : () => { }

    onFeedbackSubmit = (typeof onFeedbackSubmit === 'function')
        ? onFeedbackSubmit
        : () => { }

    const subHeaderText = (message.data && message.data.length && message.data[0].subHeaderText)
        ? message.data[0].subHeaderText
        : ''
    const placeholder_text=(message?.commentsText)
    ? message?.commentsText
    : ''
    const submitButton=(message?.buttons[0].displayText )
    ? message?.buttons[0].displayText 
    : ''
    const submittedButton=(message?.buttons[1].displayText )
    ? message?.buttons[1].displayText 
    : ''
    const submitcontinueButton=(message?.buttons[2].displayText )
    ? message?.buttons[2].displayText 
    : ''
    const submitfeedbackButton=(message?.buttons[3].displayText )
    ? message?.buttons[3].displayText 
    : ''
    const cancelButton=(message?.buttons[4].displayText )
    ? message?.buttons[4].displayText 
    : ''

    // Process message text to remove (optional) for Open CDO
    let processedMessage = message;
    if (isOpenCdo && message && message.text && typeof message.text === 'string') {
        processedMessage = {
            ...message,
            text: message.text.replace(/\s*\(optional\)\s*/gi, '')
        };
    }

    const inputChanged = (e) => {
        setCharacterCount(e.target.value.length)
        setInput(e.target.value);
    }

    useEffect(() => {
        var textbox = document.getElementById('improve');
        setTimeout(() => {
            textbox.focus();
        }, 500);
    }, []);

    const openCdoButtonClass = isMobile ? 'open-cdo-submit-mobile' : 'open-cdo-submit-desktop';
    const primaryButtonClass = isOpenCdo ? openCdoButtonClass : 'continue-button';

    const handleSubmit = () => {
        sendMessage('message', input, input);
        datadogRum.addAction('NpsFeedback-' + input);
        const shouldRedirect = !selfCare911ERSelected && selectedButtonRedirectUrl;

        if (shouldRedirect) {
            const url = new URL(selectedButtonRedirectUrl);
            console.log('Redirecting to deeplink:', url.toString());
            window.open(url.toString(), '_blank');
        }

        if (isOpenCdo) {
            onFeedbackSubmit(!!shouldRedirect);
            closeToast(false);
        } else {
            closeToast();
        }

        if (selfCare911ERSelected && typeof onSubmit === 'function') {
            onSubmit();
        }

    };

    const handleCancel = () => {
        sendMessage('message', '', '');
        datadogRum.addAction('NpsFeedback-Cancel');
        if (isOpenCdo) {
            closeToast(true);
        } else {
            closeToast();
        }
    };

    return (
        <div id='NpsFeedback' className={isOpenCdo ? 'open-cdo' : ''}>
            <label htmlFor="improve">
                <div className='header' style={{ color: `var(--primary-color)` }}>
                    <h2 className='headerText'>{getMarkDown(processedMessage)}</h2>
                </div>
                {!isOpenCdo && (
                    <div className='subheader' style={{ color: `var(--primary-color)` }}>
                        {getMarkDown(subHeaderText)}
                    </div>
                )}
            </label>
            <div className='body'>
                <TextField
                    className='freetextfield'
                    id="improve"
                    aria-invalid="false"
                    variant="outlined"
                    multiline
                    minRows={3}
                    maxRows={3}
                    value={input}
                    onChange={inputChanged}
                    placeholder={isOpenCdo ? `${placeholder_text} (optional)` : placeholder_text}
                    inputProps={{
                        maxLength: 250,
                        style: { marginBottom: 15, fontFamily: 'Enterprise Sans VF' }
                    }}
                    disabled={disabled}
                    fullWidth
                />
            </div>
            <div className={(isOpenCdo || characterCount) ? 'counter' : 'ghosted counter'} >
                {isOpenCdo ? `${characterCount}/${MAX_CHAR}` : MAX_CHAR - characterCount}
            </div>
            <div className={showDoubleButtons ? 'footer double-button' : 'footer'}>
                 {showDoubleButtons && (
                    <button
                        className={`${openCdoButtonClass} secondary-button`}
                        onClick={handleCancel}
                        disabled={disabled}
                    >
                        {cancelButton}
                    </button>
                )}
                <button
                     className={showDoubleButtons ? `${openCdoButtonClass} primary-button` : primaryButtonClass}
                    onClick={handleSubmit}
                    disabled={disabled}
                >
                    {isOpenCdo ? (disabled ? <><CheckmarkOpenCdo fill='#00184D' marginRight={0} />{submittedButton}</> : showDoubleButtons ? submitcontinueButton : submitfeedbackButton) :  submitButton}
                </button>
            </div>
        </div >
    );
}

export default TextInputMessage;